import { Col, Row } from 'antd'
import React from 'react'
import classes from './cpn.module.css'
function PageTitle(props) {
    return (
        <Row>
            <Col span={8} style={{display:"flex",alignItems:'flex-end',paddingBottom:"20px"}}></Col>
            <Col span={8}><div className={classes.form_title}>{props.title}</div></Col>
            <Col span={8} style={{display:"flex",alignItems:'flex-end',paddingBottom:"20px"}}></Col>
        </Row>
    )
}

export default PageTitle